import {
  FieldMappingEditorValue,
  FormLinkDraft,
} from '@components/text-editors/addons/field-mapping';

// Matches one named variable rather than every `unique_link` field, so an email
// containing two form links only previews the one being edited.
export const applyFormLinkDraft = (
  content: FieldMappingEditorValue | undefined,
  draft: FormLinkDraft | null
): FieldMappingEditorValue | undefined => {
  if (!content || !draft || !content.variables) return content;
  const variables = Object.fromEntries(
    Object.entries(content.variables).map(([name, entry]) => [
      name,
      name === draft.variableName
        ? { ...entry, linkType: draft.linkType, linkLabel: draft.linkLabel }
        : entry,
    ])
  );
  return { ...content, variables };
};
